import { useEffect, useState } from 'react';

/**
 * 检测是否为 PC 端的自定义 Hook
 * 优先根据 UA 判断是否为桌面端
 * @param breakpoint 备用断点宽度（仅在无法读取 UA 时使用），默认为 768px
 * @returns 是否为 PC 端
 */
export const useIsPc = (breakpoint: number = 768): boolean => {
  const [isPc, setIsPc] = useState<boolean>(true);

  useEffect(() => {
    const detectPc = () => {
      if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        setIsPc(true);
        return;
      }

      const ua = navigator.userAgent || navigator.vendor || (window as any).opera || '';
      const uaLower = ua.toLowerCase();

      // 常见移动端 UA 关键字
      const mobileKeywords = [
        'android',
        'iphone',
        'ipad',
        'ipod',
        'windows phone',
        'mobile',
        'opera mini',
        'blackberry',
        'webos',
      ];

      const isMobileByUA = mobileKeywords.some((keyword) => uaLower.includes(keyword));

      if (isMobileByUA) {
        setIsPc(false);
        return;
      }

      // UA 不是明显移动端时，用宽度兜底
      setIsPc(window.innerWidth >= breakpoint);
    };

    detectPc();
    window.addEventListener('resize', detectPc);
    return () => {
      window.removeEventListener('resize', detectPc);
    };
  }, [breakpoint]);

  return isPc;
};

